import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section8Text17 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, joinHomeRegistryMortgage} = context.data.pdfData;

  return (
    <div ref={ref}>
      {joinHomeRegistryMortgage && identifyMethodType === 2 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>משכנתא: </span>
          <span>{getBreakLinesTextShumaType3(joinHomeRegistryMortgage)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text17;
